import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import PageManagerTreeViewItem from './tree-view-item.js';

const PageManagerTreeViewItemContainer = ({
  node,
  isOpen = false,
  onToggle = Function.prototype,
  isDragging = false,
  isDropTarget = false,
  onItemClick = Function.prototype,
  selectModeEnabled = false,
  selectedItemsMap = {},
  onItemSelect = Function.prototype,
}) => {
  const handleClick = useCallback(() => {
    if (node.data) {
      if (node.droppable) {
        onToggle();
      }

      onItemClick(node.data);
    }
  }, [node, onToggle, onItemClick]);

  if (!node.data) {
    return null;
  }

  const item = node.data;

  let { iconGlyph } = item;

  if (node.droppable) {
    iconGlyph = isOpen ? 'bottom' : 'small-right-arrow';
  }

  return (
    <PageManagerTreeViewItem
      id={item.id}
      name={item.name}
      title={item.title}
      password={item.password}
      iconGlyph={iconGlyph}
      isActive={item.isActive}
      actions={item.actions}
      isEmpty={isDragging}
      isDropTarget={isDropTarget}
      selectModeEnabled={selectModeEnabled}
      selectedItemsMap={selectedItemsMap}
      onItemSelect={onItemSelect}
      onClick={handleClick}
    />
  );
};

PageManagerTreeViewItemContainer.propTypes = {
  node: PropTypes.shape({
    droppable: PropTypes.bool,
    data: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      title: PropTypes.string,
      password: PropTypes.string,
      iconGlyph: PropTypes.string,
      isActive: PropTypes.bool,
      actions: PropTypes.arrayOf(PropTypes.shape({})),
    }),
  }).isRequired,
  selectModeEnabled: PropTypes.bool,
  selectedItemsMap: PropTypes.shape({}),
  onItemSelect: PropTypes.func,
  isOpen: PropTypes.bool,
  onToggle: PropTypes.func,
  isDragging: PropTypes.bool,
  isDropTarget: PropTypes.bool,
  onItemClick: PropTypes.func,
};

export default React.memo(PageManagerTreeViewItemContainer);
